export const blockIconsEditorTextFields = (
	<span className='material-symbols-outlined'>text_fields</span>
);
